import { gql } from "gql";

export const SEND_COMMENT = gql(/* GraphQL */ `
  mutation SendComment($postId: ID!, $comment: String!) {
    sendComment(postId: $postId, comment: $comment)
  }
`);
